var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.35355 0.735314C7.54882 0.930576 7.54882 1.24716 7.35355 1.44242L1.70711 7.08887L7.35355 12.7353C7.54882 12.9306 7.54882 13.2472 7.35355 13.4424C7.15829 13.6377 6.84171 13.6377 6.64645 13.4424L0.646447 7.44242C0.451184 7.24716 0.451184 6.93058 0.646447 6.73531L6.64645 0.735314C6.84171 0.540052 7.15829 0.540052 7.35355 0.735314Z",
    fill: "#252B5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.6416150d401d17d1781b644386bc2727.svg";
export { ForwardRef as ReactComponent };